import React, { Component } from 'react';
import RUTransportsAtDTable from './RUTransportsAtDTable';


export class RUTransportsAtDContent extends Component {

  constructor(props) {
    super(props);
    this.state = {
      content: this.props.showContent
    };
  }

  render() {

    return (
      <div>
        {this.state.content === 'ruTransportsAtDestination' ?
          <RUTransportsAtDTable handleChangeContent={this.props.handleChangeContent.bind(this)} />
          : null
        }
      </div>
    )

  }
}

export default RUTransportsAtDContent;


// WEBPACK FOOTER //
// ./src/components/UsedRentals/UsedRentalsTransport/UsedRentalsAtDestination/RUTransportsAtDContent.js